import * as React from 'react';
import { IntlProvider } from 'react-intl';
// import  from "./../translations"
import I18n from "./../i18n/I18n";
import AppRouter from '../router';


function App() {
	return <I18n>
		<AppRouter />
	</I18n>
}
export default App;
